export enum QueriesEnum {
  reservations = 'reservations',
  makeReservation = 'makeReservation',
  cancellationReservation = 'cancellationReservation',
  getMyPhotos = 'getMyPhotos',
}
